export const setLandTrustMapReference = (map) => {
    return {
        type: 'SET_LAND_TRUST_MAP_REFERENCE',
        payload: map
    }
}

export const setLandTrustMapReferenceNull = () => {
    return {
        type: 'SET_LAND_TRUST_MAP_REFERENCE_NULL',

    }
}